import { useState } from "react";
import { freshNews } from "@/mocks/gua";

const groupCats = Array.from(new Set(freshNews.map((n) => n.cat)));
const cats = ["全部", ...groupCats];

export default function NewsFeed() {
  const [active, setActive] = useState("全部");

  const filtered = active === "全部" ? freshNews : freshNews.filter((n) => n.cat === active);

  return (
    <section id="fresh" className="mt-16 scroll-mt-24 px-4 md:mt-20 md:px-6">
      <div className="mx-auto max-w-[1240px]">
        <div className="mb-6 flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              最新速递 · 一线热讯
            </h2>
            <p className="mt-1 text-sm text-foreground-500">24 小时内最值得跟进的事件动态，标注分类随时切换</p>
          </div>
          {/* 分类切换 */}
          <div className="flex flex-wrap items-center gap-1 rounded-lg bg-background-100 p-1">
            {cats.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs transition-colors ${
                  active === c
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-50"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((n) => (
            <article
              key={n.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100/50 transition-colors hover:border-primary-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={n.img}
                  alt={`${n.title} 新闻配图`}
                  className="h-44 w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 whitespace-nowrap rounded bg-background-50/90 px-2 py-0.5 text-xs font-medium text-primary-700 backdrop-blur">
                  {n.cat}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 text-base font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                  {n.title}
                </h3>
                <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" /> {n.time}
                  </span>
                  <span className="flex items-center gap-3">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line" /> {n.views}万
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-message-3-line" /> {n.comments.toLocaleString()}
                    </span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}